const CMEAppointmentTypes = {
    "Initial": 1,
    "Re-Eval": 2,
    "Supplemental": 3
};

export default CMEAppointmentTypes;